import { render, staticRenderFns } from "./DashboardBottomInfo.vue?vue&type=template&id=26729d54&scoped=true"
import script from "./DashboardBottomInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardBottomInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26729d54",
  null
  
)

export default component.exports